import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowUpRight } from "lucide-react";
import SaveLookButton from "../components/SaveLookButton";

function DropCard({ drop }) {
    return (
        <article data-testid={`drop-card-${drop.id}`} className="group grain-card rounded-md overflow-hidden hover-lift">
            <div className="relative aspect-[4/5] overflow-hidden">
                <img src={drop.image_url} alt={drop.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="absolute top-3 left-3 flex items-center gap-2 px-2 py-1 bg-black/60 backdrop-blur-md rounded">
                    <span className="font-mono-tag text-[10px] uppercase text-brand-saffron">/ {drop.startup_name}</span>
                </div>
                <SaveLookButton imageUrl={drop.image_url} title={drop.title} source="drop"
                    startupId={drop.startup_id} dropId={drop.id} className="absolute top-3 right-3 z-20" />
            </div>
            <div className="p-5">
                <h3 className="font-display font-extrabold text-xl md:text-2xl tracking-tight leading-tight mb-1">{drop.title}</h3>
                <p className="text-white/60 text-sm line-clamp-2 mb-4">{drop.description}</p>
                <div className="flex items-center justify-between">
                    <Link to={`/startup/${drop.startup_id}`} className="font-mono-tag text-[11px] uppercase text-white/70 hover:text-brand-saffron transition-colors">
                        View brand →
                    </Link>
                    {drop.link_url && (
                        <a href={drop.link_url} target="_blank" rel="noopener noreferrer"
                           onClick={() => api.post("/analytics/track", { event: "drop_click", drop_id: drop.id, startup_id: drop.startup_id }).catch(() => {})}
                           data-testid={`drop-shop-${drop.id}`}
                           className="font-mono-tag text-[11px] uppercase text-brand-saffron flex items-center gap-1 hover:text-brand-marigold transition-colors">
                            Shop drop <ArrowUpRight className="w-3 h-3" />
                        </a>
                    )}
                </div>
            </div>
        </article>
    );
}

export default function Drops() {
    const [drops, setDrops] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/drops").then((r) => setDrops(r.data)).finally(() => setLoading(false));
    }, []);

    return (
        <main className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-20 min-h-screen">
            <p className="font-mono-tag text-xs uppercase text-brand-saffron mb-3">/ drops</p>
            <h1 data-testid="drops-title" className="font-display font-extrabold text-4xl md:text-6xl tracking-tighter uppercase mb-4">
                The <span className="text-brand-saffron">campaign</span> feed.
            </h1>
            <p className="text-white/70 text-base md:text-lg max-w-2xl mb-12">
                Editorial-style campaigns from every brand on Primates. New collections, seasonal edits, and the drops you don't want to miss.
            </p>

            {loading ? (
                <p className="font-mono-tag text-xs uppercase text-white/50">Loading...</p>
            ) : drops.length === 0 ? (
                <div className="border border-dashed border-white/15 rounded-md py-24 text-center">
                    <p className="font-display text-2xl mb-2">No drops yet.</p>
                    <p className="text-white/60 text-sm">Brands are dropping soon — check back in a bit.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                    {drops.map((d) => <DropCard key={d.id} drop={d} />)}
                </div>
            )}
        </main>
    );
}
